import { render, staticRenderFns } from "./RedeGP.vue?vue&type=template&id=515f2b6c&scoped=true"
import script from "./RedeGP.vue?vue&type=script&lang=js"
export * from "./RedeGP.vue?vue&type=script&lang=js"
import style0 from "./RedeGP.vue?vue&type=style&index=0&id=515f2b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515f2b6c",
  null
  
)

export default component.exports